import { useState } from "react";
import {
  FiEdit2,
  FiCalendar,
  FiChevronDown,
  FiEye,
} from "react-icons/fi";

import {
  FaFlask,
  FaStethoscope,
  FaPills,
  FaXRay,
} from "react-icons/fa";

import { BsClipboard2Pulse } from "react-icons/bs";
import { MdOutlineWaterDrop } from "react-icons/md";

const orders = [
  {
    id: "ORD-2026-00125",
    type: "Lab Test",
    details: "CBC (Complete Blood Count)",
    doctor: "Dr. Hari Prakash",
    orderedOn: "01 Jul 2026",
    time: "10:30 AM",
    status: "Pending",
    priority: "Routine",
    icon: <FaFlask className="text-blue-600" />,
  },
  {
    id: "ORD-2026-00124",
    type: "Procedure",
    details: "12 Lead ECG",
    doctor: "Dr. Hari Prakash",
    orderedOn: "01 Jul 2026",
    time: "10:25 AM",
    status: "Completed",
    priority: "Routine",
    icon: <FaStethoscope className="text-green-600" />,
  },
  {
    id: "ORD-2026-00123",
    type: "Medication",
    details: "Paracetamol 650 mg",
    doctor: "Dr. Hari Prakash",
    orderedOn: "01 Jul 2026",
    time: "10:20 AM",
    status: "In Progress",
    priority: "Routine",
    icon: <FaPills className="text-pink-600" />,
  },
  {
    id: "ORD-2026-00122",
    type: "Radiology",
    details: "Chest X-Ray (PA View)",
    doctor: "Dr. Hari Prakash",
    orderedOn: "30 Jun 2026",
    time: "04:15 PM",
    status: "Completed",
    priority: "Routine",
    icon: <FaXRay className="text-yellow-600" />,
  },
  {
    id: "ORD-2026-00121",
    type: "Fluid",
    details: "Normal Saline 0.9%",
    doctor: "Dr. Hari Prakash",
    orderedOn: "30 Jun 2026",
    time: "02:45 PM",
    status: "Completed",
    priority: "High",
    icon: <MdOutlineWaterDrop className="text-purple-600" />,
  },
  {
    id: "ORD-2026-00120",
    type: "Consultation",
    details: "Dietitian Consultation",
    doctor: "Dr. Hari Prakash",
    orderedOn: "30 Jun 2026",
    time: "11:30 AM",
    status: "Pending",
    priority: "Routine",
    icon: <BsClipboard2Pulse className="text-orange-600" />,
  },
];

export default function Orders() {
  const [tab, setTab] = useState("All Orders");

  const filtered =
    tab === "All Orders"
      ? orders
      : orders.filter((x) => x.status === tab);

  return (
    <div className="rounded-xl border bg-white shadow-sm">

      {/* Header */}

      <div className="border-b px-5 py-4 flex justify-between">
        <h2 className="text-lg font-bold text-[#283593]">
          Doctor Orders
        </h2>
             <input
                    type="date"
                    className="h-8 rounded-md border border-[#e5e7eb] bg-white px-4 text-[13px] font-semibold text-[#111827] outline-none focus:border-[#5b5bd6]"
                  />
      </div>

      {/* Top */}

      <div className="flex flex-wrap items-center justify-between gap-4 p-5">

        {/* Tabs */}

        <div className="flex rounded-lg border overflow-hidden">

          {[
            "All Orders",
            "Pending",
            "In Progress",
            "Completed",
          ].map((item) => (
            <button
              key={item}
              onClick={() => setTab(item)}
              className={`px-5 py-2 text-xs font-semibold transition

              ${
                tab === item
                  ? "bg-cyan-600 text-white"
                  : "bg-white hover:bg-gray-50"
              }`}
            >
              {item}
            </button>
          ))}

        </div>

        {/* Filters */}

        <div className="flex gap-3">

   

      <div className="relative">
  <select
    className="rounded-lg border border-gray-300 bg-white px-4 py-2 pr-10 text-xs outline-none focus:border-cyan-500"
  >
    <option>All Order Types</option>
    <option>Lab Test</option>
    <option>Medication</option>
    <option>Procedure</option>
    <option>Radiology</option>
    <option>Fluid</option>
    <option>Consultation</option>
  </select>

  {/* <FiChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-500" /> */}
</div>

        </div>

      </div>
            {/* Table */}
      <div className="overflow-x-auto px-5 pb-5">
        <table className="min-w-full text-xs">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <th className="p-3 text-left"></th>
              <th className="p-3 text-left">Order ID</th>
              <th className="p-3 text-left">Order Type</th>
              <th className="p-3 text-left">Order Details</th>
              <th className="p-3 text-left">Ordered By</th>
              <th className="p-3 text-left">Ordered On</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Priority</th>
              <th className="p-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((item, index) => (
              <tr
                key={index}
                className="border-t hover:bg-gray-50 transition"
              >
                {/* Icon */}
                <td className="p-3">
                  <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-100 text-lg">
                    {item.icon}
                  </div>
                </td>

                {/* Order ID */}
                <td className="p-3 font-semibold text-[#3b3f97]">
                  {item.id}
                </td>

                {/* Type */}
                <td className="p-3">{item.type}</td>

                {/* Details */}
                <td className="p-3">
                  <div className="font-medium">
                    {item.details}
                  </div>

                  {item.type === "Lab Test" && (
                    <div className="text-[10px] text-gray-500">
                      Sample : Whole Blood
                    </div>
                  )}

                  {item.type === "Medication" && (
                    <div className="text-[10px] text-gray-500">
                      1 Tablet • Oral • TID
                    </div>
                  )}

                  {item.type === "Radiology" && (
                    <div className="text-[10px] text-gray-500">
                      View : PA
                    </div>
                  )}

                  {item.type === "Fluid" && (
                    <div className="text-[10px] text-gray-500">
                      500 ml • IV
                    </div>
                  )}

                  {item.type === "Consultation" && (
                    <div className="text-[10px] text-gray-500">
                      Review Diet Plan
                    </div>
                  )}
                </td>

                {/* Doctor */}
                <td className="p-3">
                  {item.doctor}
                </td>

                {/* Ordered On */}
                <td className="p-3">
                  <div>{item.orderedOn}</div>

                  <div className="text-[10px] text-gray-500">
                    {item.time}
                  </div>
                </td>

                {/* Status */}
                <td className="p-3">
                  <span
                    className={`rounded-md px-2 py-1 text-[10px] font-semibold
                    ${
                      item.status === "Completed"
                        ? "bg-green-100 text-green-700"
                        : item.status === "Pending"
                        ? "bg-orange-100 text-orange-700"
                        : "bg-blue-100 text-blue-700"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>

                {/* Priority */}
                <td className="p-3">
                  <span
                    className={`rounded-md px-2 py-1 text-[10px] font-semibold
                    ${
                      item.priority === "High"
                        ? "bg-red-100 text-red-600"
                        : "bg-indigo-100 text-indigo-700"
                    }`}
                  >
                    {item.priority}
                  </span>
                </td>

                {/* Action */}
           <td className="p-3 text-center">
  <button className="rounded-lg border border-blue-300 px-3 py-1 text-[11px] font-semibold text-blue-600 hover:bg-blue-50">
    <FiEye className="mr-1 inline" />
    View
  </button>
</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
            {/* Footer */}
      <div className="flex flex-col items-center justify-between gap-4 border-t px-5 py-4 md:flex-row">

        {/* Left */}
        <p className="text-xs text-gray-500">
          Showing 1 to {filtered.length} of {filtered.length} entries
        </p>

        {/* Pagination */}
        <div className="flex items-center gap-2">

          <button className="flex h-8 w-8 items-center justify-center rounded-md border text-gray-500 hover:bg-gray-100">
            &laquo;
          </button>

          <button className="flex h-8 w-8 items-center justify-center rounded-md bg-cyan-600 text-white">
            1
          </button>

          <button className="flex h-8 w-8 items-center justify-center rounded-md border hover:bg-gray-100">
            2
          </button>

          <button className="flex h-8 w-8 items-center justify-center rounded-md border text-gray-500 hover:bg-gray-100">
            &raquo;
          </button>

        </div>

        {/* Rows Per Page */}
        <div className="flex items-center gap-2 text-xs">

          <span className="text-gray-500">
            Rows per page
          </span>

          <select className="rounded-md border px-2 py-1 outline-none">
            <option>10</option>
            <option>20</option>
            <option>50</option>
          </select>

        </div>

      </div>

    </div>
  );
}